// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image_kQSgx { 
  flex : 0 0 auto;
  width : 125px;
  height : 96px;
  object-fit : contain;
  background : var( --color-white );
  padding : 8px 16px;
}

.title_PKQDs {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width : 217px;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/recovrGeneric/dashboard/viewer/theftRecovery/views/ImageUploader.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;AACf","sourcesContent":[".image { \n  flex : 0 0 auto;\n  width : 125px;\n  height : 96px;\n  object-fit : contain;\n  background : var( --color-white );\n  padding : 8px 16px;\n}\n\n.title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width : 217px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `image_kQSgx`,
	"title": `title_PKQDs`
};
export default ___CSS_LOADER_EXPORT___;
